module.exports = __webpack_public_path__ + "static/media/fal_fal_exa_ins.ecf40864.png";